import { createSelector } from '@reduxjs/toolkit';

import { isBetRequiredToChat } from '../../../utils/chat';
import { type CoreRootState, useCoreSelector } from '../../CoreStore';

import { gameChatMessagesAdapter, liveSupportChatMessagesAdapter } from './slice';
import type { Message, ChatSubscriptionState } from './types';

const { selectAll: selectLiveSupportChatMessages } = liveSupportChatMessagesAdapter.getSelectors<CoreRootState>(
  (state) => state.chat.liveSupportChatMessages
);

const { selectAll: selectGameChatMessages } = gameChatMessagesAdapter.getSelectors<CoreRootState>(
  (state) => state.chat.gameChatMessages
);

const miniChatMessages = createSelector([(state): Message[] => selectGameChatMessages(state)], (messages) =>
  messages.slice(0, 3)
);

export const useChatSlice = {
  getGameChatMessages: (): Message[] => {
    return useCoreSelector((state) => selectGameChatMessages(state));
  },
  getLiveSupportChatMessages: (): Message[] => {
    return useCoreSelector((state) => selectLiveSupportChatMessages(state));
  },
  getMiniChatMessages: (): Message[] => {
    return useCoreSelector(miniChatMessages);
  },
  getLastChatMessage: (): Message | null => {
    return useCoreSelector((state) => state.chat.lastChatMessage);
  },
  getChatSubscriptionState: (): ChatSubscriptionState => {
    return useCoreSelector((state) => state.chat.chatSubscriptionState);
  },
  getIsLiveSupportRead: (): boolean => {
    return useCoreSelector((state) => state.chat.isLiveSupportChatRead);
  },
  getIsLiveSupportChatBlocked: (): boolean => {
    return useCoreSelector((state) => state.chat.isLiveSupportChatBlocked);
  },
  getIsGameChatBlocked: (): boolean => {
    return useCoreSelector((state) => state.chat.isGameChatBlocked);
  },
  getIsBetChatAllowed: (): boolean => {
    return useCoreSelector((state) => state.chat.isBetChatAllowed);
  },
  isBetRequiredToChat: (): boolean => {
    return useCoreSelector((state) => isBetRequiredToChat(state.chat.chatBlockType));
  },
  getIsChatHistoryFetched: (): boolean => {
    return useCoreSelector((state) => state.chat.isGameChatHistoryFetched);
  },
};
